import React, { useEffect } from 'react';
import './landingPage.css';
import { goalsPageRoute, tasksPageRoute } from '../../common/linkRoutes';
import { useStore } from '../../store/store';
import Layout from '../../components/layout/Layout';
import { BasicProps } from '../goals/GoalPage';
import firebase from '../../firebase/initFirebase';
import googleLogo from '../../assets/logos/google-logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { useListVals } from 'react-firebase-hooks/database';
import { goalRef, taskRef } from '../../firebase/refs';
import { updateAllTaskStatus } from '../../store/actions/dailyTaskActions';
import { updateAllGoalStatus } from '../../store/actions/goalActions';

type LandingProps = BasicProps & {
  hideTopbar?: Boolean | undefined;
};

const LandingPage = (props: LandingProps) => {
  const { setRedirect, loginWith, logout, loadUser, user } = useStore();
  
  
  const { updateTaskStatus, updateGoalStatus } = useStore();

  const [taskRefList] = useListVals<any>(taskRef);
  const [goalRefList] = useListVals<any>(goalRef);

  // update goals/tasks status
  useEffect(() => {
    if (taskRefList && taskRefList.length) {
      updateAllTaskStatus(taskRefList, updateTaskStatus);
    }
    if (goalRefList && goalRefList.length) {
      updateAllGoalStatus(goalRefList, updateGoalStatus);
    }

    return () => {
      taskRef.off();
      goalRef.off();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    loadUser();

    const isLoaded = localStorage.getItem('goalOrg-first-loaded');
    const addShowMenu = () => {
      const _buttons = document.getElementById('buttons');
      _buttons?.classList.add('show');
    };
    if (!isLoaded) {
      setTimeout(() => {
        localStorage.setItem('goalOrg-first-loaded', 'true');
        addShowMenu();
      }, 3000);
    } else {
      addShowMenu();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const signInWithGoogle = () => {
    const _provider = new firebase.auth.GoogleAuthProvider();
    loginWith(_provider);
  };

  return (
    <Layout pageName="Landing Page" hideTopbar={true} {...props}>
      {user && (
        <div style={{ opacity: '0.3', fontWeight: 'bold' }}>
          <span style={{ textTransform: 'capitalize' }}>
            {user.displayName}
          </span>
          , You can do it!
        </div>
      )}
      <div className="landing-page">
        <div className="landing-page__heading">
          <h1 className="heading_head">Goal Organizer</h1>
          <p className="heading_sub">"One day at a time"</p>
        </div>

        {!user ? (
          <div id="buttons" className="landing-page__button-container">
            <h4>Get Started With:</h4>
            <button
              className="btn bg-black"
              onClick={signInWithGoogle}
              style={{
                textTransform: 'capitalize',
                justifyContent: 'center',
                alignContent: 'center',
              }}
            >
              <img
                src={googleLogo}
                alt="google logo"
                style={{ width: '2.2rem', marginRight: '0.5rem' }}
              />
              Google Account
            </button>
          </div>
        ) : (
          <div id="buttons" className="landing-page__button-container">
            <button
              onClick={() => setRedirect(goalsPageRoute)}
              className="btn bg-black"
            >
              Goals<span>→</span>
            </button>
            <button
              onClick={() => setRedirect(tasksPageRoute)}
              className="btn bg-black"
            >
              Daily Tasks<span>→</span>
            </button>

            <button onClick={logout} className="landing-page__button-signout">
              SIGN OUT
            </button>
          </div>
        )}
      </div>

      <div
        style={{
          display: 'flex',
          width: ' 100%',
          justifyContent: ' space-between',
          padding: '1rem 0px',
          opacity: '0.1',
          alignItems: 'flex-end',
        }}
      >
        <div onClick={() => window.location.reload()}>v(beta)1.2</div>
        <div>
          <a
            href="https://www.instagram.com/shelomoh"
            target="_blank"
            rel="noreferrer"
            style={{ fontSize: '0.9rem' }}
          >
            made with 🖤 by
            <br />
            <span style={{ fontWeight: 'bold' }}>shelomoh</span>
          </a>
        </div>
        <div
          className="clickable update-button"
          onClick={() => window.location.reload()}
        >
          UPDATE
          <FontAwesomeIcon
            icon={faSync}
            style={{
              marginLeft: '.5rem',
            }}
          />
        </div>
      </div>
    </Layout>
  );
};

export default LandingPage;
